import React, { useEffect, useState } from "react";
import { Compass } from "lucide-react";
import api from "@/lib/api";

export const CurioVaultCard = () => {
  const [fact, setFact] = useState(null);

  useEffect(() => {
    api.get("/curiovault/featured").then((r) => setFact(r.data)).catch(() => setFact({ url: "https://curiovault.co" }));
  }, []);

  const url = fact?.url || "https://curiovault.co";

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="curiovault-card"
      className="group bg-ink text-white border border-ink rounded-2xl p-5 shadow-sm h-full flex gap-3 hover:border-gold transition-colors"
    >
      {fact?.image_url ? (
        <img src={fact.image_url} alt="" className="w-14 h-14 shrink-0 rounded-lg object-cover border border-gold/40" />
      ) : (
        <span className="w-10 h-10 shrink-0 rounded-lg flex items-center justify-center bg-ink border border-gold text-gold">
          <Compass className="w-5 h-5" />
        </span>
      )}
      <div className="flex flex-col min-w-0 flex-1">
        <p className="text-[11px] font-semibold tracking-wide text-gold">From CurioVault</p>
        <h3 className="font-semibold text-white mt-0.5">Today's curiosity</h3>
        <p data-testid="curiovault-hook" className="mt-1 text-sm text-white/75 leading-relaxed flex-1 line-clamp-3">
          {fact ? fact.hook || "Strange-but-true stories from our sister site." : "Loading a curiosity…"}
        </p>
        <span data-testid="curiovault-cta" className="mt-3 self-start text-[12px] font-semibold text-gold group-hover:underline">
          Read on CurioVault.co →
        </span>
      </div>
    </a>
  );
};
